export default __webpack_public_path__ + "static/sampleimage2-9ada2dd0c31e0ad0344da6e1e172d43b.svg";